import { ExpiredOfflineObjectAsyncTimestampRemover } from '../abstract/expired-offline-object-async-timestamp-remover';
import { ImmoIPProductChangesObject } from './immo-ip-product-changes-object';

export class ExpiredImmoIPProductChangesRemover extends ExpiredOfflineObjectAsyncTimestampRemover<
  number,
  ImmoIPProductChangesObject
> {}
